const CONFIG = {
  apiUrl: process.env.REACT_APP_API_URL || "https://api.flopchop.com",
  serverUrl: process.env.REACT_APP_SERVER_URL || "https://game.flopchop.com",
}

CONFIG["logoutUrl"] = CONFIG.apiUrl + "/auth/logout"

export default CONFIG
